import Vue from 'vue';
import { transformDna } from '../util/transformDna';

export default {

    // ****
    // ****

    getGame (state) {

        return state.game;
        
    },

    getGames (state) {

        return state.games.sort((a, b) => {
            let winnerA = a.winner ? 1 : 0;
            let winnerB = b.winner ? 1 : 0;

            if (winnerA < winnerB) return 1;
            if (winnerA > winnerB) return -1;

            if (a.isComplete > b.isComplete) return 1;
            if (a.isComplete < b.isComplete) return -1;

            let rewardA = parseFloat(a.reward);
            let rewardB = parseFloat(b.reward);

            if (rewardA < rewardB) return 1;
            if (rewardA > rewardB) return -1;

            return 0;
        });

    },

    // **************
    // User interface

    getModalType (state) {
        return state.modalType;
    },

    getLoading (state) {
        return state.loading;
    },

    getHasExtension (state) {
        return state.hasExtension;
    },

    getPendingTransaction (state) {
        return state.pendingTransaction;
    },

    getHasError (state) {
        return state.hasError;
    },

    getLocale (state) {
        return state.locale;
    },

    getContentLoading (state) {
        return state.contentLoading;
    }

}



// WEBPACK FOOTER //
// ./src/store/getters.js